import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import admin_45global from "/app/middleware/admin.global.ts";
import auth_45global from "/app/middleware/auth.global.ts";
import owner_45global from "/app/middleware/owner.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  admin_45global,
  auth_45global,
  owner_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/app/middleware/admin.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  owner: () => import("/app/middleware/owner.ts")
}